// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimItemDTO } from '../models';
import { CreateClaimItemDTO } from '../models';
import { UpdateClaimItemDTO } from '../models';
/**
 * ClaimItemsApi - axios parameter creator
 * @export
 */
export const ClaimItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Claim Item
         * @param {string} claimId Claim id 
         * @param {CreateClaimItemDTO} createClaimItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimItem(claimId: string, createClaimItemDTO: CreateClaimItemDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling createClaimItem.');
            }
            // verify required parameter 'createClaimItemDTO' is not null or undefined
            if (createClaimItemDTO === null || createClaimItemDTO === undefined) {
                throw new RequiredError('createClaimItemDTO','Required parameter createClaimItemDTO was null or undefined when calling createClaimItem.');
            }
            const localVarPath = `/v2/claims/{claimId}/items`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateClaimItemDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createClaimItemDTO !== undefined ? createClaimItemDTO : {}) : (createClaimItemDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Claim Item on a Claim
         * @param {string} claimId Claim id 
         * @param {string} claimItemId Claim Item id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItem(claimId: string, claimItemId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deleteClaimItem.');
            }
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling deleteClaimItem.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Claim Item on a Claim
         * @param {string} claimId Claim id 
         * @param {string} claimItemId Claim Item id 
         * @param {UpdateClaimItemDTO} updateClaimItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimItem(claimId: string, claimItemId: string, updateClaimItemDTO: UpdateClaimItemDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling updateClaimItem.');
            }
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling updateClaimItem.');
            }
            // verify required parameter 'updateClaimItemDTO' is not null or undefined
            if (updateClaimItemDTO === null || updateClaimItemDTO === undefined) {
                throw new RequiredError('updateClaimItemDTO','Required parameter updateClaimItemDTO was null or undefined when calling updateClaimItem.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateClaimItemDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateClaimItemDTO !== undefined ? updateClaimItemDTO : {}) : (updateClaimItemDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimItemsApi - functional programming interface
 * @export
 */
export const ClaimItemsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a Claim Item
         * @param {string} claimId Claim id 
         * @param {CreateClaimItemDTO} createClaimItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimItem(claimId: string, createClaimItemDTO: CreateClaimItemDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemDTO> {
            const localVarAxiosArgs = ClaimItemsApiAxiosParamCreator(configuration).createClaimItem(claimId, createClaimItemDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Claim Item on a Claim
         * @param {string} claimId Claim id 
         * @param {string} claimItemId Claim Item id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItem(claimId: string, claimItemId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimItemsApiAxiosParamCreator(configuration).deleteClaimItem(claimId, claimItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a Claim Item on a Claim
         * @param {string} claimId Claim id 
         * @param {string} claimItemId Claim Item id 
         * @param {UpdateClaimItemDTO} updateClaimItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimItem(claimId: string, claimItemId: string, updateClaimItemDTO: UpdateClaimItemDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimItemsApiAxiosParamCreator(configuration).updateClaimItem(claimId, claimItemId, updateClaimItemDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimItemsApi - factory interface
 * @export
 */
export const ClaimItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a Claim Item
         * @param {string} claimId Claim id 
         * @param {CreateClaimItemDTO} createClaimItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimItem(claimId: string, createClaimItemDTO: CreateClaimItemDTO, options?: any) {
            return ClaimItemsApiFp(configuration).createClaimItem(claimId, createClaimItemDTO, options)(axios, basePath);
        },
        /**
         * Delete a Claim Item on a Claim
         * @param {string} claimId Claim id 
         * @param {string} claimItemId Claim Item id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItem(claimId: string, claimItemId: string, options?: any) {
            return ClaimItemsApiFp(configuration).deleteClaimItem(claimId, claimItemId, options)(axios, basePath);
        },
        /**
         * Update a Claim Item on a Claim
         * @param {string} claimId Claim id 
         * @param {string} claimItemId Claim Item id 
         * @param {UpdateClaimItemDTO} updateClaimItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimItem(claimId: string, claimItemId: string, updateClaimItemDTO: UpdateClaimItemDTO, options?: any) {
            return ClaimItemsApiFp(configuration).updateClaimItem(claimId, claimItemId, updateClaimItemDTO, options)(axios, basePath);
        },
    };
};

/**
 * ClaimItemsApi - interface
 * @export
 * @interface ClaimItemsApi
 */
export interface ClaimItemsApiInterface {
    /**
     * Create a Claim Item
     * @param {string} claimId Claim id 
     * @param {CreateClaimItemDTO} createClaimItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemsApiInterface
     */
    createClaimItem(claimId: string, createClaimItemDTO: CreateClaimItemDTO, options?: any): AxiosPromise<ClaimItemDTO>;

    /**
     * Delete a Claim Item on a Claim
     * @param {string} claimId Claim id 
     * @param {string} claimItemId Claim Item id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemsApiInterface
     */
    deleteClaimItem(claimId: string, claimItemId: string, options?: any): AxiosPromise<object>;

    /**
     * Update a Claim Item on a Claim
     * @param {string} claimId Claim id 
     * @param {string} claimItemId Claim Item id 
     * @param {UpdateClaimItemDTO} updateClaimItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemsApiInterface
     */
    updateClaimItem(claimId: string, claimItemId: string, updateClaimItemDTO: UpdateClaimItemDTO, options?: any): AxiosPromise<object>;

}

/**
 * ClaimItemsApi - object-oriented interface
 * @export
 * @class ClaimItemsApi
 * @extends {BaseAPI}
 */
export class ClaimItemsApi extends BaseAPI implements ClaimItemsApiInterface {
    /**
     * Create a Claim Item
     * @param {string} claimId Claim id 
     * @param {CreateClaimItemDTO} createClaimItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemsApi
     */
    public createClaimItem(claimId: string, createClaimItemDTO: CreateClaimItemDTO, options?: any) {
        return ClaimItemsApiFp(this.configuration).createClaimItem(claimId, createClaimItemDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Claim Item on a Claim
     * @param {string} claimId Claim id 
     * @param {string} claimItemId Claim Item id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemsApi
     */
    public deleteClaimItem(claimId: string, claimItemId: string, options?: any) {
        return ClaimItemsApiFp(this.configuration).deleteClaimItem(claimId, claimItemId, options)(this.axios, this.basePath);
    }

    /**
     * Update a Claim Item on a Claim
     * @param {string} claimId Claim id 
     * @param {string} claimItemId Claim Item id 
     * @param {UpdateClaimItemDTO} updateClaimItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemsApi
     */
    public updateClaimItem(claimId: string, claimItemId: string, updateClaimItemDTO: UpdateClaimItemDTO, options?: any) {
        return ClaimItemsApiFp(this.configuration).updateClaimItem(claimId, claimItemId, updateClaimItemDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimItemsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a Claim Item
 * @param {string} claimId Claim id 
 * @param {CreateClaimItemDTO} createClaimItemDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createClaimItem(
    claimId: string,
    createClaimItemDTO: CreateClaimItemDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemDTO> {
    const localVarAxiosArgs = ClaimItemsApiAxiosParamCreator(configuration).createClaimItem(claimId, createClaimItemDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Claim Item on a Claim
 * @param {string} claimId Claim id 
 * @param {string} claimItemId Claim Item id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteClaimItem(
    claimId: string,
    claimItemId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimItemsApiAxiosParamCreator(configuration).deleteClaimItem(claimId, claimItemId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a Claim Item on a Claim
 * @param {string} claimId Claim id 
 * @param {string} claimItemId Claim Item id 
 * @param {UpdateClaimItemDTO} updateClaimItemDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateClaimItem(
    claimId: string,
    claimItemId: string,
    updateClaimItemDTO: UpdateClaimItemDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimItemsApiAxiosParamCreator(configuration).updateClaimItem(claimId, claimItemId, updateClaimItemDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

